import style from '@aytm/app/stats/page/question-views/components/styles/Preloader.module.scss'

// The veil a block draws over what it is showing while fresh numbers are on the way. It fills
// whatever it is placed in, so the block only says when to show it.
const Preloader = () => (
  <div className={style.loader}>
    <span className={style['loader-spinner']} />
  </div>
)

Preloader.displayName = 'Preloader'

export default Preloader
